var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstantIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10438",
    "data-name": "Group 10438",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.488,
    height: 59.498,
    viewBox: "0 0 39.488 59.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4346",
    "data-name": "Rectangle 4346",
    width: 39.488,
    height: 59.498,
    fill: "#ef7b13"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10437",
    "data-name": "Group 10437",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44428",
    "data-name": "Path 44428",
    d: "M12.9,59.5c-1.267-.844-1.411-1.262-1.01-2.874q2.794-11.236,5.583-22.473c.036-.146.06-.294.107-.532h-.724c-4.955,0-9.911-.022-14.866.014A1.8,1.8,0,0,1,.014,31.673a2.728,2.728,0,0,1,.17-.61Q5.924,16.21,11.671,1.36A1.78,1.78,0,0,1,13.663.031C18.793.031,23.923.08,29.051,0a1.889,1.889,0,0,1,1.825,2.854c-2.191,4.837-4.3,9.71-6.445,14.57-.091.207-.166.421-.276.7h.685q6.359,0,12.717,0a1.712,1.712,0,0,1,1.915,1.93,2.542,2.542,0,0,1-.413,1Q27.628,38.883,16.181,56.7a15.616,15.616,0,0,1-.918,1.408c-.4.5-.878.932-1.322,1.394ZM26.72,3.536c-.153-.012-.23-.023-.306-.023-3.793,0-7.587.007-11.38-.012-.407,0-.515.2-.634.507Q9.475,16.755,4.542,29.5c-.072.187-.12.383-.193.621h.7q7.316,0,14.632,0a1.752,1.752,0,0,1,1.824,2.309q-1.49,6.042-3,12.08c-.25,1.007-.492,2.016-.738,3.023l.1.036L34.541,21.624h-.759q-6.039,0-12.077,0a1.777,1.777,0,0,1-1.755-2.7q1.731-3.952,3.476-7.9L26.72,3.536",
    transform: "translate(0 0)",
    fill: "#ef7b13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantIcon);
export default __webpack_public_path__ + "static/media/instant-icon.40581929925527b1c59ea51883e0ede0.svg";
export { ForwardRef as ReactComponent };